import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import i18n from "../../../i18n";
import {route} from "../../../routes";
import {
  GelContentContainer,
  ContentCard,
  GelContentRow,
  InfographicCard, List,
  ScaleCard,
  StackedCard,
  StatCard,Link,
  Utility, Sanitize
} from "cw-styleguide-react";
import SecondaryAutocompleteSearch from "../../../components/SecondaryAutocompleteSearch";
import Helmet from 'react-helmet';

class JobDetailView extends Component {
  render() {
    return (
      <Fragment>

        <Helmet>
          <title>{this.props.data.name} | {this.props.t('route_app_title')}</title>
        </Helmet>
        <GelContentContainer>
          <h1>{this.props.data.name}</h1>
          <GelContentRow>

            {/* Introduction */}
            {this.props.data.overview &&
            <StackedCard
              size={''}
              link={false}
              imageRight={true}
              colour={'brand-a'}
              source={this.props.data.image.src}
              alt={this.props.data.image.alt}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobRole')
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_role_title')}
              classes={'card--option'}
            >
              <Sanitize html={this.props.data.overview} />
            </StackedCard>
            }

          </GelContentRow>


          <GelContentRow classes={['js-equalize-cards']}>

            {/* Pay */}

            <ScaleCard
              width={66}
              title={this.props.t('pay_title')}
              from={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') :  (this.props.data.pay.starting ? "£" + this.props.data.pay.starting.toLocaleString() : '')}
              to={this.props.data.pay.variesFlag ? this.props.t('styleguide:pay_varies') :  (this.props.data.pay.experienced ? "£" + this.props.data.pay.experienced.toLocaleString() + (this.props.data.pay.moreFlag ? "+" : "" )  : '')}
              start={this.props.t('styleguide:pay_starting')}
              end={this.props.t('styleguide:pay_experienced')}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobPay') + '#' + Utility.slug(this.props.t('pay_title'))
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_pay_title')}
            />


            {/* Hours @TODO */}

            <StatCard
              link={false}
              width={33}
              colour={'brand-f'}
              title={this.props.t('typical_hours_title')}
              rows={
                [
                  {
                    icon: 'clock',
                    figure: !(this.props.data.hours.hoursIrregular == "Yes") ? this.props.data.hours.hours : '',
                    text: (this.props.data.hours.hoursIrregular && this.props.data.hours.hoursIrregular == "Yes" ?  <p>{this.props.t('typical_hours_irregular')}</p> :   <p> {this.props.t('typical_hours_counter')}</p>)
                  },
                  {
                    icon: (this.props.data.hours.shiftPatterns && this.props.data.hours.shiftPatterns.length) ? 'calendar' : '',
                    text: this.props.data.hours.shiftPatterns && this.props.data.hours.shiftPatterns.map((shift) => {
                      return <p>{shift}</p>
                    })
                  }
                ]
              }
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobPay') + '#' + Utility.slug(this.props.t('hours_of_work_title'))
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('typical_hours_title')/*this.props.t('route_pay_title')*/}
            />


          </GelContentRow>
         <GelContentRow classes={['js-equalize-cards']}>

            {/* Qualifications */}
            <StatCard
              link={false}
              width={33}
              colour={'brand-d'}
              size="large"
              title={this.props.t('qualifications_title')}
              rows={[
                {
                  icon: 'qualification', text:
                    !!this.props.data.qualifications.qualification ? '<p>' + Object.values(this.props.data.qualifications.qualification).join('</p><p>' + this.props.t('view.jobDetail.pay.upTo') + '</p><p>') + '</p>' :  ''
                }
              ]}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobBecome') + '#' + Utility.slug(this.props.t('qualifications_title'))
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('view.jobDetail.qualifications.title')/*this.props.t('route_become_title')*/}
              classes={['card--option']}
            />


            {/* Openings  @todo */}

            <InfographicCard
              link={false}
              width={33}
              size={'large'}
              colour={'brand-f'}
              title={this.props.data.openingsData.text }
              source={"https://publicfiles.careerswales.gov.wales/jobs/job-information/content/d7-info-graphic.jpg"}
              stat={this.props.data.openingsData.value && {counter: this.props.data.openingsData.value}}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobBecome') + '#' + Utility.slug(this.props.t('future_demand_title')),
                title: this.props.t('openings_title')
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('view.jobDetail.openings.title')/*(this.props.openingsText? this.props.openingsText : this.props.t('route_become_title'))*/}
              classes={['infographic--lmi']}
            >
              <p>{this.props.data.lightcastRefYear}</p>
            </InfographicCard>


            {/* Demand */}

            <StatCard
              width={33}
              size={'large'}
              colour={'brand-a'}
              title={this.props.t('future_demand_title')}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobBecome') + '#' + Utility.slug(this.props.t('future_demand_title'))
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' +  this.props.t('view.jobDetail.futureDemand.title')/*this.props.t('route_become_title')*/}
              rows={[
                {
                  icon: 'chart', figure: this.props.data.futureDemand.trend, text:
                    <Fragment>
                      {/*<p>{!this.props.demandText && this.props.demandLevel}</p>*/}
                      <p>{this.props.data.futureDemand.text}</p>
                      <p>{this.props.data.lightcastRefYear}</p>
                    </Fragment>
                }
              ]}
              classes={['card--option']}
            />


          </GelContentRow>


          <GelContentRow classes={['js-equalize-cards']}>

            {/* Become */}
            {!!this.props.data.howToBecomeData.dashboardText &&
            <ContentCard
              width={66}
              colour={'brand-b'}
              title={this.props.t('how_to_become_title')}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobBecome')
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_become_title')}
            >
              <Sanitize html={this.props.data.howToBecomeData.dashboardText}/>
            </ContentCard>
            }

            {/* Health  @todo */}

            <StatCard
              width={33}
              colour={'brand-d'}
              title={this.props.t('health_considerations_title')}
              rows={
                [
                  {icon: 'health', text: this.props.data.healthConsiderations.dashboardText}, // @todo
                  {text: (this.props.data.healthConsiderations.active && this.props.data.healthConsiderations.active.activeIndicator) ? this.props.data.healthConsiderations.active.text : ''}
                ]
              }
              readMore={this.props.data.healthConsiderations.showHealthConsiderationsFlag && {
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobBecome')
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('health_considerations_title')/*this.props.t('route_become_title')*/}
            />


        </GelContentRow>
         <GelContentRow classes={['js-equalize-cards']}>

            {/* Skills */}

            <ContentCard
              width={33}
              title={this.props.t('skills_and_qualities_title')}
              readMore={{
                to: route('job', {job: this.props.data.slug}) + '/' + route('jobSkills')
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_skills_title')}
            >
              <Sanitize html={this.props.data.skillsAndQualitiesData.dashboardText} classes={['style','style--list-circle','style--list-no-bg']}/>
            </ContentCard>


            {/* Subjects */}

            <ContentCard
              width="33"
              title={this.props.t('relevant_subjects_title')}
              readMore={{
                to:route('job', {job: this.props.data.slug}) + '/' + route('jobSkills') + '#' + Utility.slug(this.props.t('relevant_subjects_title'))
              }}
              hiddenText={this.props.t('styleguide:about') + ' ' + this.props.t('route_subjects_title')}
            >


              {!!this.props.data.skillsAndQualitiesData.recommendedSubjects && <Sanitize html={this.props.data.skillsAndQualitiesData.recommendedSubjects} classes={['style','style--list-circle','style--list-no-bg']} />}
              {!!this.props.data.skillsAndQualitiesData.usefulSubjects && <Sanitize html={this.props.data.skillsAndQualitiesData.usefulSubjects} classes={['style','style--list-circle','style--list-no-bg']} />}


            </ContentCard>


              {/* Related */}
            {!!this.props.data.relatedJobs &&
            <ContentCard
              width="33"
              title={this.props.t('related_jobs_title')}
            >
              <List styles={['list-circle', 'list-no-bg']} items={this.props.data.relatedJobs.map((subject) => {
                return <Link to={"/" + subject.slug} >{subject.name}</Link>
              })}/>
            </ContentCard>
            }

          </GelContentRow>

          {/* Links */}

          <Fragment>
            <hr className="thick"/>
            <h2>{this.props.t('useful_links_title')}</h2>
            {i18n.language === 'cy' &&
            <p>Mae rhai o’r dolenni hyn yn Saesneg yn unig.</p>

            }

            <Sanitize html={this.props.data.usefulLinks} tag={"div"} classes={['style--columns-2','style--list-large']} />

          </Fragment>


          {/* Websites */}
          <Fragment>
            <hr className="thick"/>
            <h2>{this.props.t('job_websites_title')}</h2>
            {i18n.language === 'cy' &&
            <p>Mae rhai o’r dolenni hyn yn Saesneg yn unig.</p>
            }

            <Sanitize html={this.props.data.jobSites}  tag={"div"} classes={['style--columns-2', 'style--list-large']}  />
            <div className={'style--columns-2 style--list-large'}>
            <ul>
                {this.props.data.apprenticeships.apprenticeshipsIndicator && <li> <Sanitize html={this.props.data.apprenticeships.apprenticeshipsUrl}/></li>}
            {/*  <li><a href={this.props.t('find_a_job_link')}>{this.props.t('find_a_job')}</a></li>*/}
            {/*  <li><a href={this.props.t('indeed_link')}>{this.props.t('indeed')}</a></li>*/}
            {/*  <li><a href={this.props.t('total_jobs_link')}>{this.props.t('total_jobs')}</a></li>*/}
            {/*  <li><a href={this.props.t('jobsite_link')}>{this.props.t('jobsite')}</a></li>*/}
            </ul>
            </div>


          </Fragment>

          <hr className="thick"/>
          <SecondaryAutocompleteSearch jobs={this.props.jobs}/>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withTranslation('local')(JobDetailView);
